import React, { useState, useEffect } from "react";
import styled from "styled-components"

import PanelCurrencyInformation from "./PanelCurrencyInformation"
import PanelCurrencyBalance from "./PanelCurrencyBalance"
import PanelCurrencySymbol from "./PanelCurrencySymbol"
import PanelCurrencyName from "./PanelCurrencyName"
import PanelCurrencyLogo from "./PanelCurrencyLogo"

import { IMAGES_FOLDER } from "../config"


const _OracleCurrencySelector = styled.div`
	cursor: pointer;
    margin: 0, auto;
	padding: 0.25em;
	padding-left: 1.5em;
	padding-right: 1.5em;
	display:flex;
    opacity: ${({ isValidateCurrencyChoice }) => isValidateCurrencyChoice ? "1" : "0.3"};
    cursor: ${({ isValidateCurrencyChoice }) => isValidateCurrencyChoice ? "pointer" : "default"};

	&:hover {
		background-color: ${({ theme }) => theme.currencySelectorBackgroundColorHover};
	}
`;


function OracleCurrencySelector(props) {
	const [isValidateCurrencyChoice, setIsValidateCurrencyChoice] = useState(true)
	useEffect(() => {
		async function validate() {
			const v = await props.validateCurrency(props.currency)
			setIsValidateCurrencyChoice(v)
		}
		validate()
	}, [props.currency])
	return (
		<_OracleCurrencySelector isValidateCurrencyChoice={isValidateCurrencyChoice} onClick={props.selectCurrency(props.currency)}>
			<PanelCurrencyLogo src={require("../" + IMAGES_FOLDER + props.currency["symbol"].toLowerCase() + "-logo.png")}/>
			<PanelCurrencyInformation>
				<PanelCurrencySymbol>{props.currency["symbol"]}</PanelCurrencySymbol>
				<PanelCurrencyName>{props.currency["name"]}</PanelCurrencyName>
				<PanelCurrencyBalance tokenTargetQuantity={undefined} web3={props.web3} account={props.account} token={props.currency} />
			</PanelCurrencyInformation>
		</_OracleCurrencySelector>
	)

}

const _OracleCurrencySelectorPanel = styled.div`
	text-align: center;
	height: 50vh;
	overflow: scroll;
	align-self: center;
    color: ${({ theme }) => theme.oracleCurrencySelectorPanelTextColor};
    background-color: ${({ theme }) => theme.oracleCurrencySelectorPanelBackgroundColor};
    border-radius: 0.5em;
    padding: 1px;
    padding-top: 1em;
    padding-bottom: 0.5em;
    display: flex;
    flex-direction: column;
    width: 50%;

	/* Tablets */
	@media (max-width: 1400px) {
    	width: 60%;
	}

	/* Mobiles */
	@media (max-width: 640px) {
    	width: 95%;
	}

`;

function OracleCurrencySelectorPanel(props) {
	return (
		<_OracleCurrencySelectorPanel ref={props.handleRef}>
			{
				props.currencies != undefined ?
				<div>
				{
					props.currencies.map((currency, index) => <OracleCurrencySelector web3={props.web3} account={props.account} validateCurrency={props.validateCurrency} selectCurrency={props.selectCurrency} key={index} currency={currency} />)
				}
				</div>
				:
				<div style={{textAlign: "center", alignSelf: "middle"}}> No tokens found 😞</div>
			}
		</_OracleCurrencySelectorPanel>
	)
}

const _OracleCurrencySelectorPanelWrapper = styled.div`
	width:100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.6);
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	display: flex;
	justify-content: center;
`;


function OracleCurrencySelectorPanelWrapper(props) {
	return (
	<>
		{
			props.showCurrencySelector ? <_OracleCurrencySelectorPanelWrapper><OracleCurrencySelectorPanel web3={props.web3} account={props.account} validateCurrency={props.validateCurrency} selectCurrency={props.selectCurrency} handleRef={props.handleRef} currencies={props.currencies}/></_OracleCurrencySelectorPanelWrapper> : <></>
		}
	</>
	)
}

export default OracleCurrencySelectorPanelWrapper;
